var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "@ethersproject/bignumber";
import { useContext } from "react";
import { VaultLiquidityMiningMap, } from "../constants/constants";
import { SubgraphDataContext } from "./subgraphDataContext";
var getLMAccountKey = function (vault) {
    return "lmAccount_" + vault.replace(/-/g, "");
};
export var liquidityMiningPoolAccountsGraphql = function (account, version) {
    return version === "v1"
        ? Object.keys(VaultLiquidityMiningMap.lm).reduce(function (acc, curr) {
            return acc +
                ("\n  " + getLMAccountKey(curr) + ": vaultLiquidityMiningPoolAccount(id:\"" + VaultLiquidityMiningMap.lm[curr].toLowerCase() + "-" + account.toLowerCase() + "\") {\n              pool {\n                numDepositors\n                totalSupply\n                totalRewardClaimed\n              }\n              totalRewardClaimed\n              totalBalance\n            }\n  ");
        }, "")
        : "";
};
export var resolveLiquidityMiningPoolAccountsSubgraphResponse = function (responses) {
    return Object.fromEntries(Object.keys(VaultLiquidityMiningMap.lm).map(function (vaultOption) {
        var data = responses["v1"]
            ? responses["v1"][getLMAccountKey(vaultOption)]
            : undefined;
        return [
            vaultOption,
            data
                ? __assign(__assign({}, data), { totalRewardClaimed: BigNumber.from(data.totalRewardClaimed), totalBalance: BigNumber.from(data.totalBalance), pool: __assign(__assign({}, data.pool), { totalSupply: BigNumber.from(data.pool.totalSupply), totalRewardClaimed: BigNumber.from(data.pool.totalRewardClaimed) }) }) : undefined,
        ];
    }));
};
var useLiquidityMiningPoolAccounts = function () {
    var context = useContext(SubgraphDataContext);
    return {
        stakingAccounts: context.vaultSubgraphData.stakingAccounts.lm,
        loading: context.vaultSubgraphData.loading,
    };
};
export default useLiquidityMiningPoolAccounts;
//# sourceMappingURL=useLiquidityMiningPoolAccounts.js.map